import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const companyCreateBank: TypedDocumentNode<
    Pick<GQL.IMutation, "companyCreateBank">,
    GQL.IMutationCompanyCreateBankArgs
> = gql`
    mutation companyCreateBank($input: CompanyCreateBankInput!) {
        companyCreateBank(input: $input) {
            id
        }
    }
`;
export const companyUpdateBankYearConfig: TypedDocumentNode<
    Pick<GQL.IMutation, "companyUpdateBankYearConfig">,
    GQL.IMutationCompanyUpdateBankYearConfigArgs
> = gql`
    mutation companyUpdateBank($input: CompanyUpdateBankInput!) {
        companyUpdateBankYearConfig(input: $input) {
            id
        }
    }
`;
export const companyDeleteBank: TypedDocumentNode<
    Pick<GQL.IMutation, "companyDeleteBank">,
    GQL.IMutationCompanyDeleteBankArgs
> = gql`
    mutation companyDeleteBank($input: CompanyNumEntityDeleteInput!) {
        companyDeleteBank(input: $input) {
            id
        }
    }
`;

export const companyCreateKB: TypedDocumentNode<
    Pick<GQL.IMutation, "companyCreateKB">,
    GQL.IMutationCompanyCreateKbArgs
> = gql`
    mutation companyCreateKB($input: CompanyCreateKBInput!) {
        companyCreateKB(input: $input) {
            id
        }
    }
`;
export const companyUpdateKBYearConfig: TypedDocumentNode<
    Pick<GQL.IMutation, "companyUpdateKBYearConfig">,
    GQL.IMutationCompanyUpdateKbYearConfigArgs
> = gql`
    mutation companyUpdateKB($input: CompanyUpdateKBInput!) {
        companyUpdateKBYearConfig(input: $input) {
            id
        }
    }
`;
export const companyDeleteKB: TypedDocumentNode<
    Pick<GQL.IMutation, "companyDeleteKB">,
    GQL.IMutationCompanyDeleteKbArgs
> = gql`
    mutation companyDeleteKB($input: CompanyNumEntityDeleteInput!) {
        companyDeleteKB(input: $input) {
            id
        }
    }
`;

export const companyMarkFavoriteBank: TypedDocumentNode<
    Pick<GQL.IMutation, "companyMarkFavoriteBank">,
    GQL.IMutationCompanyMarkFavoriteBankArgs
> = gql`
    mutation companyMarkFavoriteBank($input: IDCompanyIDInput!, $isFavorite: Boolean) {
        companyMarkFavoriteBank(input: $input, isFavorite: $isFavorite) {
            id
            year
            isFavorite
        }
    }
`;

export const companyMarkFavoriteKB: TypedDocumentNode<
    Pick<GQL.IMutation, "companyMarkFavoriteKB">,
    GQL.IMutationCompanyMarkFavoriteKbArgs
> = gql`
    mutation companyMarkFavoriteKB($input: IDCompanyIDInput!, $isFavorite: Boolean) {
        companyMarkFavoriteKB(input: $input, isFavorite: $isFavorite) {
            id
            year
            isFavorite
        }
    }
`;
